module.exports = __webpack_public_path__ + "img/nbus_mt.83a74e51.png";